import ReactGA from "react-ga4";

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_ID;

export const initGA = () => {
  ReactGA.initialize(GA_MEASUREMENT_ID);
};

export const trackPage = (page) => {
  ReactGA.send({ hitType: "pageview", page });
};

export const trackEvent = (action, category, label) => {
  ReactGA.event({
    action,
    category,
    label
  });
};
